/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React, { useCallback, useEffect, useState } from 'react';

import Form from 'react-jsonschema-form';
import { fields } from './fields';
import { widgets } from './widgets';
import { templates } from './templates';
import { fixIncompleteSchema } from '../common/fixIncompleteSchema';

const FormCommon = React.forwardRef((props, ref) => {

    const {
        schema,
        uiSchema,
        formData,
        onSubmit,
        onChange,
        children,
        liveValidate,
        showErrorList,
        formContext,
        customWidgets,
        customFields,
        customTemplates,
        transformErrors
    } = props;

    // widgets, fields and templates can be passed as props. Merging them with the default FormCommon ones
    const mergedWidgets = {
        ...widgets,
        ...customWidgets
    };

    const mergedFields = {
        ...fields,
        ...customFields
    };

    const mergedTemplates = {
        ...templates,
        ...customTemplates
    };

    const [localSchema, setLocalSchema] = useState({});
    const [localFormData, setLocalFormData] = useState(formData);
    useEffect(() => {
        // Ignoring $id/id as this causes issues in schema validation
        const { $id, id, ...filteredSchema } = schema;

        // some schemas may be incomplete (missing items definitions for array types, etc.)
        fixIncompleteSchema(filteredSchema);
        setLocalSchema(filteredSchema);
    }, [schema]);

    useEffect(() => {
        setLocalFormData(formData);
    }, [formData]);

    const _onChange = useCallback((state) => {
        setLocalFormData(state.formData);
        onChange && onChange(state);
    }, [onChange]);

    return (
        <Form schema={localSchema}
            uiSchema={uiSchema}
            formData={localFormData}
            widgets={mergedWidgets}
            fields={mergedFields}
            FieldTemplate={mergedTemplates.FieldTemplate}
            ObjectFieldTemplate={mergedTemplates.ObjectFieldTemplate}
            ArrayFieldTemplate={mergedTemplates.ArrayFieldTemplate}
            onChange={_onChange}
            liveValidate={liveValidate}
            showErrorList={showErrorList}
            onSubmit={onSubmit}
            ref={ref}
            formContext={formContext}
            transformErrors={transformErrors}
        >
            {children}
        </Form>
    );
});

export { FormCommon };